import type { ThemeColorType } from 'src/styles/theme';

import { HorizontalRule } from './styles';

interface DividerProps {
  width?: string;
  backgroundColor?: ThemeColorType;
  margin?: string;
}

export const Divider = ({ width, backgroundColor, margin }: DividerProps) => (
  <HorizontalRule width={width} backgroundColor={backgroundColor} margin={margin} />
);
